import { render, staticRenderFns } from "./Suscriptions.vue?vue&type=template&id=49e4d58a&scoped=true"
import script from "./Suscriptions.vue?vue&type=script&lang=js"
export * from "./Suscriptions.vue?vue&type=script&lang=js"
import style0 from "./Suscriptions.vue?vue&type=style&index=0&id=49e4d58a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e4d58a",
  null
  
)

export default component.exports